import { Component, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { finalize } from 'rxjs';
import Swal from 'sweetalert2';

import { AuthService } from '../../../core/services/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './primeiro-acesso.html',
  styleUrl: './primeiro-acesso.css',
})
export class PrimeiroAcesso {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  auth = inject(AuthService);

  etapa: 'email' | 'senha' = 'email';

  loading = false;
  erro = '';
  email = '';

  mostrarSenhaProvisoria = false;
  mostrarNovaSenha = false;
  mostrarConfirmacao = false;

  formEmail = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
  });

  form = this.fb.nonNullable.group({

    novaSenha: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(128)]],
    confirmacao: ['', Validators.required],
  });

  // ETAPA 1: SOLICITAR PRIMEIRO ACESSO
  continuar(): void {
    console.log('CONTINUAR FOI CHAMADO');

    console.log('Formulário válido:', this.formEmail.valid);
    console.log('Valores:', this.formEmail.getRawValue());

    if (this.loading) return;

    if (this.formEmail.invalid) {
      this.formEmail.markAllAsTouched();
      this.erro = 'Informe um e-mail válido.';
      this.cdr.detectChanges();
      return;
    }

    const emailInformado = this.formEmail.getRawValue().email.trim();

    this.loading = true;
    this.erro = '';

    console.log('CHAMANDO BACKEND COM EMAIL:', emailInformado);

    this.auth.solicitarPrimeiroAcesso(emailInformado)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (resposta) => {
          console.log('RESPOSTA DO BACKEND:', resposta);

          this.email = emailInformado;
          this.etapa = 'senha';

          this.form.reset();
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('ERRO DO BACKEND:', error);

          this.erro = 'Não foi possível continuar.';
          this.cdr.detectChanges();
        }
      });
  }

  // VOLTAR PARA A ETAPA DO E-MAIL
  voltar(): void {
    if (this.loading) return;

    this.etapa = 'email';
    this.erro = '';
    this.email = '';

    this.form.reset();
    this.cdr.detectChanges();
  }

  // ETAPA 2: CONCLUIR PRIMEIRO ACESSO
  salvar(): void {
    if (this.loading) return;

    if (this.etapa !== 'senha' || !this.email) {
      this.erro = 'Informe seu e-mail antes de continuar.';
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.erro = 'Preencha corretamente todos os campos.';
      this.cdr.detectChanges();
      return;
    }

    const v = this.form.getRawValue();

    if (v.novaSenha !== v.confirmacao) {
      this.erro = 'As senhas não coincidem.';
      this.cdr.detectChanges();
      return;
    }



    this.loading = true;
    this.erro = '';

    this.auth
      .concluirPrimeiroAcesso(this.email,  v.novaSenha)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: async () => {
          await Swal.fire({
            icon: 'success',
            title: 'Primeiro acesso concluído!',
            text: 'Sua nova senha foi cadastrada com sucesso. Faça login para continuar.',
            confirmButtonText: 'Ir para o login',
            confirmButtonColor: '#064F82',
            allowOutsideClick: false,
          });

          this.auth.logout();

          await this.router.navigateByUrl('/login');
        },

        error: (error) => {
          console.error('Erro ao concluir primeiro acesso:', error);

          if (error.status === 409) {
            this.erro =
              'Não foi possível concluir o primeiro acesso. Verifique seus dados ou entre pelo login.';
          } else if (error.status === 400) {
            this.erro = 'Não foi possível validar os dados informados. Confira a senha provisória.';
          } else if (error.status === 401 || error.status === 403) {
            this.erro = 'A solicitação não foi autorizada. Verifique os dados e tente novamente.';
          } else {
            this.erro = 'Não foi possível cadastrar a nova senha. Tente novamente.';
          }

          this.cdr.detectChanges();
        },
      });
  }
}
